/**
 * Product.
 *
 * @param {Object} params - Object parameter
 * @param {string} params.id - Unique identifier
 * @param {string} params.name - Product name
 * @param {array}  params.subProducts - Product sub-products
 * @param {integer} params.organizer_id - Product organizer_id
 * @param {boolean} params.is_for_buyer - Product is_for_buyer
 * @constructor
 */

import SubProduct from "./subProduct";
import Category from "./category";

export default class Product {
	constructor({
		id,
		name,
		subProducts,
		organizerId = null,
		isForBuyer = false,
		category = null
	} = {}) {
		this.id = id;
		this.name = name;
		this.subProducts = subProducts || [];
		this.isForBuyer = isForBuyer;
		this.organizerId = organizerId;
		this.category = category;
	}

	static buildFromJSON(json) {
		return new Product({
			id: json.id,
			name: json.name ?? "",
			subProducts: json.sub_products?.map(SubProduct.buildFromJSON) ?? [],
			organizerId: json.organizer_id ?? null,
			isForBuyer: json.is_for_buyer ?? false,
			category: json.category
				? Category.buildFromJSON(json.category)
				: null
		});
	}

	toJSON() {
		return {
			id: this.id,
			name: this.name,
			sub_products: this.subProducts,
			is_for_buyer: this.isForBuyer,
			organizer_id: this.organizerId
		};
	}

	getId() {
		return this.id;
	}

	getName() {
		return this.name;
	}

	getSubProducts() {
		return this.subProducts;
	}

	getFirstSubProduct() {
		return this.subProducts[0] ?? null;
	}

	getFirstSubProductName() {
		return this.getFirstSubProduct()?.getName() ?? null;
	}

	getSubProductById(id) {
		return this.subProducts.find(subProduct => subProduct.getId() === id);
	}

	getIsForBuyer() {
		return this.isForBuyer;
	}

	getOrganizerId() {
		return this.organizerId;
	}

	getCategory() {
		return this.category;
	}
}
